import { AppProvider } from "@/config/providers"
import { AppRoutes } from "@/config/routes"
import { datadogRum } from "@datadog/browser-rum"
import * as Sentry from "@sentry/react"
import React from "react"
import ReactDOM from "react-dom"
import { gqlClient } from "./util/graphql"
import { redirectToLogin } from "./util/url"

// ローカル環境ではSentry, Datadogは使用しない
if (import.meta.env.MODE !== "base") {
	Sentry.init({
		dsn: "https://691ac7b976a3418a827bc64077e20eb9@o1016873.ingest.sentry.io/6294499",
		integrations: [new Sentry.BrowserTracing()],
		environment: import.meta.env.MODE,
		// VITE_RELEASE の値は GitHub Actions による deploy workflow の中でセットされる
		release: import.meta.env.VITE_RELEASE ?? "local",
		// This sets the sample rate to be 10%. You may want this to be 100% while
		// in development and sample at a lower rate in production
		replaysSessionSampleRate: 0.1,

		// If the entire session is not sampled, use the below sample rate to sample
		// sessions when an error occurs.
		replaysOnErrorSampleRate: 1.0,
	})

	datadogRum.init({
		applicationId: "6c9880e9-a888-4b12-86aa-a47e14ad05e2",
		clientToken: "pubb0c482ba84cbe0c8bc80f51d8a939539",
		site: "datadoghq.com",
		service: "Service Manager",
		env: import.meta.env.MODE,
		sampleRate: 100,
		trackInteractions: true,
		trackUserInteractions: true,
	})
	datadogRum.startSessionReplayRecording()
}

gqlClient()
	.user()
	.then((result) => {
		const user = result.user
		if (user === undefined) {
			// ログインページへ移動
			location.href = redirectToLogin()
			return
		}

		const { id, officeId, email, name } = user
		localStorage.setItem("userId", id)
		localStorage.setItem("officeId", officeId ?? "")
		localStorage.setItem("email", email ?? "")
		localStorage.setItem("name", name ?? "")

		if (typeof id === "string" && typeof officeId === "string") {
			Sentry.setUser({ id })
			Sentry.setTag("office_id", officeId)
			Sentry.setTag("cs_slack_mention", `cs_mention_office_${officeId}:`)

			// 監視サービスに送信された情報がどの組織のものかを判定可能とするために、ユーザー名にはoffice id を設定する
			const username = `Office ID: ${officeId}`
			datadogRum.setUser({ id, username })
		}
	})

ReactDOM.render(
	<React.StrictMode>
		<AppProvider>
			<AppRoutes />
		</AppProvider>
	</React.StrictMode>,
	document.getElementById("root"),
)
